
let URLConfig = {
   
	//HOST_API: 'http://srvhdesa001:8044/',
    HOST_API: 'http://localhost/CPLT.MR_WebApiSOLR/',

    EXCLUDE_BEGIN: ["http://", "https://"],
 
    EXCLUDE_END: ['.html', '.json'],

    VIRTUAL_DIR: '/'
}

export default URLConfig;


// WEBPACK FOOTER //
// ./src/busqueda/config/url.config.js